import React, { useEffect, useState } from 'react';
import { animate, motion } from 'framer-motion';
interface MissedCallCounterProps {
  to: number;
  /** Delay (s) before the count starts climbing. */
  delay?: number;
  duration?: number;
  label?: React.ReactNode;
  numberClassName?: string;
  labelClassName?: string;
}

/** The payoff figure — calls accumulating into one number. */
export function MissedCallCounter({
  to,
  delay = 0,
  duration = 1.4,
  label = <>
      Missed
      <br data-id="element-225" data-mp="2kambn598gaat" />
      calls
    </>,
  numberClassName = 'text-[124px] leading-[0.82] text-[#0B1712]',
  labelClassName = 'text-[14px] text-[#8A998F]'
}: MissedCallCounterProps) {
  const [value, setValue] = useState(0);
  useEffect(() => {
    const controls = animate(0, to, {
      duration,
      delay,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: latest => setValue(Math.round(latest))
    });
    return () => controls.stop();
  }, [to, delay, duration]);
  return <motion.div className="flex items-end gap-4" initial={{
    opacity: 0,
    y: 12
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.9,
    delay,
    ease: [0.22, 0.61, 0.36, 1]
  }} data-id="element-226" data-mp="26j7r2tzog11n">
      <span className={`font-semibold tracking-[-0.045em] tabular-nums ${numberClassName}`} data-id="element-227" data-mp="14j2m4b9m9qp0">
        {value}
      </span>
      <span className={`pb-3 font-semibold uppercase tracking-[0.26em] ${labelClassName}`} data-id="element-228" data-mp="vp7gl24l1y8u">
        {label}
      </span>
    </motion.div>;
}